import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { v_DispatchBus } from '@app/cp/shared/models/v_DispatchBus';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import * as _ from 'lodash';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DashboardWidgetService } from '@app/cp/shared/services/dashboardWidget.service';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { DashboardQueries } from '@app/cp/shared/enums/DashboardQueries';
import { RowArgs, SelectionEvent } from '@progress/kendo-angular-grid';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'cp-status-gauge',
    templateUrl: './status-gauge.component.html',
    styleUrls: ['./status-gauge.component.scss']
})
export class StatusGaugeComponent extends BaseGridComponent<v_DispatchBus, null>  {

    compFeatureFlagSet: IFeatureFlagSet = this as any;

    widgetQuery: DashboardQueries = DashboardQueries.dispatchStatusGauge;
    searchParam: WidgetSearch;
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_data: DispatchesService, private svc_dashWidget: DashboardWidgetService, private svc_dashboard: DashboardService) {
        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
    }

    @Input() inputData: any;
    @Input() dataFilter: WidgetSearch;
    @Input() changeCheck: string;
    @Output() openRequest = new EventEmitter<any>();

    loaderState: boolean = true;

    dispatches: v_DispatchBus;

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public contentTypes = WindowContents;

    initialLoad: boolean = true;

    ngOnInit() {
        this.setup(this.dataFilter);
        this.initialLoad = false;
    }

    ngOnChanges() {
        this.loaderState = true;
        if (!this.initialLoad) {
            this.setup(this.dataFilter);
        }
    }

    public selection: string[] = [];
    public selectionKey(context: RowArgs): string {
        return context.dataItem.dispatchId ;
    }
    getData() {
        this.loaderState = true;
        this.hideError();
        this.svc_data.getStatusDetailByWidgetSearch(this.searchParam).subscribe(data => {
            if (data == null || data.length == 0) {
                this.handleNetworkError(null);
            } else {
                this.dispatches = data;

                this.gridData = _.cloneDeep(data);
                this.loaderState = false;
                if (this.lastIdLoaded) {
                    this.selection = [];
                    this.selection.push(this.lastIdLoaded);
                }
            }
        },
            error => this.handleNetworkError(error));
    }

    returnError: boolean = false;

    handleNetworkError(error) {
        this.showError();
    }

    showError() {
        this.loaderState = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }

    public setup(data: WidgetSearch) {
        this.searchParam = data;
        this.getData();
    }
    lastIdLoaded: string = null;
    showDetailsPopup(id: string, type: number) {
        this.lastIdLoaded = id;
        this.selection = [];
        this.selection.push(this.lastIdLoaded);
        this.svc_dashboard.openDQOIPopup(id, type);
    }

    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }
}
